module.exports = __webpack_public_path__ + "253b0311162057c5bc9cc00203825e5d.svg";